import ErrorHandler from 'store/utils/ErrorHandler';
import Notify from 'store/utils/Notify';
import request from 'store/utils/request';
import axios from 'axios';
import * as api from './api';

import * as types from './actionTypes';

/**
 * Get features
 *
 * @param name
 */
export const getAccounts = (name = '') => async dispatch => {
  try {
    dispatch({
      type: types.GET_ACCOUNTS_REQUEST,
    });

    const { data } = await api.getAccountsRequest({ name__icontains: name });

    dispatch({
      type: types.GET_ACCOUNTS_SUCCESS,
      payload: {
        accounts: data.results,
      },
    });
  } catch (error) {
    if (axios.isCancel(error)) return;

    dispatch({
      type: types.GET_ACCOUNTS_ERROR,
      payload: {
        error: error.response.data,
      },
    });

    Notify.error({
      title: 'An error occurred',
      description: ErrorHandler.getNotificationError(error),
    });
  }
};

export const CANCEL_GET_ACCOUNTS_REQUEST_ID = 'cancel-get-accounts';
/**
 * Cancel getAccounts
 */
export const cancelGetAccounts = () => dispatch => {
  request.cancel(api.CANCEL_GET_ACCOUNTS_REQUEST_ID);
  dispatch({ type: types.CANCEL_GET_ACCOUNTS });
};
